import forge from 'node-forge'
import { devPublicKey, proPublicKey, registerPublicKey } from '@/util/publicKey'
import { isPro } from './constants'

/**
 * RSA加密密码相关数据（登录、修改密码）
 * @param text 明文
 */
export function encryptData (text) {
  const publicKey = isPro ? proPublicKey : devPublicKey
  const publicK = forge.pki.publicKeyFromPem(publicKey)
  const encrypted = publicK.encrypt(encodeURI(text), 'RSA-OAEP')
  const res = btoa(encrypted)
  return res
}

/**
 * 注册时加密
 * @param text 明文
 */
export function registerEncrypt (text) {
  // let sessionKey = "1234567890123456";
  const sessionKey = generate()
  const encryptSessionKey = encryptRsa(sessionKey, registerPublicKey)
  const data = encryptAes(text, sessionKey)

  return `encrypt-3:::${encryptSessionKey}:${data.nonce}:${data.tag}:${data.cipherText}`
}

function generate () {
  let randStr = ''
  for (let i = 0; i < 16; i++) {
    const randItem = Math.floor(Math.random() * 10)
    randStr += randItem
  }
  return randStr
}

function encryptRsa (text, key) {
  const keyFromPem = forge.pki.publicKeyFromPem(key)
  return btoa(keyFromPem.encrypt(text, 'RSA-OAEP', {
    md: forge.md.sha256.create()
  }))
}

function encryptAes (text, key) {
  const nonce = forge.random.getBytesSync(12)
  const cipher = forge.cipher.createCipher('AES-GCM', key)
  cipher.start({ iv: nonce })
  cipher.update(forge.util.createBuffer(text))
  cipher.finish()
  const cipherText = cipher.output.getBytes()
  return { nonce: btoa(nonce), tag: btoa(cipher.mode.tag.getBytes()), cipherText: btoa(cipherText) }
}
